const columns: TableColumn[] = [
  {
    Header: `Submitted`,
    accessor: `submittedAt`,
    dbKey: `submittedAt`,
    isString: false,
    isNumeric: false,
    isDate: true,
    isBool: false,
    isSortable: true
  },
  {
    Header: `From`,
    accessor: `from`,
    dbKey: `userEmail`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Subject`,
    accessor: `subject`,
    dbKey: `subject`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Description`,
    accessor: `description`,
    dbKey: `description`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Steps`,
    accessor: `steps`,
    dbKey: `steps`,
    isString: false,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Extension`,
    accessor: `extensionVersion`,
    dbKey: `diagnostics`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `WA Web`,
    accessor: `waWebVersion`,
    dbKey: `diagnostics`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  }
];

export default columns;
